// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"f1a126a4","455":"4d3b57e9","977":"cbb344db"}[chunkId] + ".chunk.js";
};